import { Controller } from "@hotwired/stimulus"

// Handles language tabs for admin forms with translatable content
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = {
    active: { type: String, default: "en" }
  }

  connect() {
    this.showLocale(this.activeValue)
  }

  switch(event) {
    event.preventDefault()
    const locale = event.currentTarget.dataset.locale
    this.activeValue = locale
    this.showLocale(locale)
  }

  showLocale(locale) {
    // Update tabs appearance
    this.tabTargets.forEach((tab) => {
      if (tab.dataset.locale === locale) {
        tab.classList.add("border-accent", "text-accent-red")
        tab.classList.remove("border-transparent", "text-gray-500")
      } else {
        tab.classList.remove("border-accent", "text-accent-red")
        tab.classList.add("border-transparent", "text-gray-500")
      }
    })

    // Show/hide panels
    this.panelTargets.forEach((panel) => {
      if (panel.dataset.locale === locale) {
        panel.classList.remove("hidden")
      } else {
        panel.classList.add("hidden")
      }
    })
  }
}
